module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasAccessUser) ? _c('div', [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.crumbs
    }
  }), _vm._v(" "), (!_vm.formSubmitted) ? _c('form', {
    staticClass: "ls-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateBeforeSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "ls-clearfix ls-md-margin-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h3', {
    staticClass: "ls-title-4"
  }, [_vm._v(_vm._s(_vm.$t('access_users.messages.access_user')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('access_users.messages.access_users_info')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "ls-label col-md-5",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('access_users.attributes.name'))
    }
  }, [_c('span', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('access_users.attributes.name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accessUser.name),
      expression: "accessUser.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "maxlength": "50",
      "name": _vm.$t('access_users.attributes.name')
    },
    domProps: {
      "value": (_vm.accessUser.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accessUser.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('access_users.attributes.name'))),
      expression: "errors.has($t('access_users.attributes.name'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('access_users.attributes.name'))))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "ls-label col-md-5",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('access_users.attributes.email'))
    }
  }, [_c('span', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('access_users.attributes.email')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accessUser.email),
      expression: "accessUser.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "maxlength": "50",
      "name": _vm.$t('access_users.attributes.email')
    },
    domProps: {
      "value": (_vm.accessUser.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accessUser.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('access_users.attributes.email'))),
      expression: "errors.has($t('access_users.attributes.email'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('access_users.attributes.email'))))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "ls-label col-md-5",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('access_users.attributes.new_password'))
    }
  }, [_c('span', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('access_users.attributes.new_password')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accessUser.password),
      expression: "accessUser.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6'),
      expression: "'required|min:6'"
    }],
    attrs: {
      "type": "password",
      "maxlength": "50",
      "autocomplete": "new-password",
      "name": _vm.$t('access_users.attributes.new_password')
    },
    domProps: {
      "value": (_vm.accessUser.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accessUser.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('access_users.attributes.new_password'))),
      expression: "errors.has($t('access_users.attributes.new_password'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('access_users.attributes.new_password'))))])])])]), _vm._v(" "), _c('div', {
    staticClass: "ls-clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ls-actions-btn"
  }, [_c('div', {
    staticClass: "ls-float-right"
  }, [_c('router-link', {
    staticClass: "ls-btn",
    attrs: {
      "to": {
        name: 'users'
      },
      "title": _vm.$t('application.button.cancel')
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "ls-btn-primary",
    attrs: {
      "type": "submit",
      "disabled": this.errors.any()
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.save')))])], 1)])])])])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-462cecaa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/access_users/Edit.vue
// module id = 765
// module chunks = 1